import React from "react";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import styles from "./DraggableFieldList.module.css";
import { FieldProps } from "../../../../../InputFieldsController/InputFieldsController.utils";
/**
 * DraggableFieldList Component
 */
interface DraggableFieldListProps {
  fields: FieldProps[];
  updateFieldOrder: (newOrder: FieldProps[]) => void;
}

const DraggableFieldList: React.FC<DraggableFieldListProps> = ({
  fields,
  updateFieldOrder,
}) => {
  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const reordered = Array.from(fields);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    updateFieldOrder(reordered);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="field-list">
        {(provided) => (
          <div
            className={styles.listContainer}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {fields.map((field, index) => (
              <Draggable key={field.id} draggableId={field.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    className={`${styles.item} ${
                      snapshot.isDragging ? styles.dragging : ""
                    }`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    {field.label || `Untitled Field (${field.type})`}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableFieldList;
